var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "formSet-page" },
    [
      _c("KeySet", {
        attrs: {
          column: _vm.column,
          button: _vm.button,
          columnOne: _vm.columnOne,
          LanguageSet: 2,
          api: "itemsConfig",
          comDataId: _vm.dataId,
          isStringTitle: _vm.isStringTitle,
          routePath: _vm.routePath
        },
        on: {
          handleClickHandle: _vm.handleClickHandle,
          handleSelect: _vm.handleSelect
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "50%",
            "append-to-body": "",
            fullscreen: true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _vm.title === "语言设置"
            ? _c("languageSet", {
                attrs: {
                  dataIdFour: _vm.tableDataId,
                  typeFour: _vm.tableDataType
                }
              })
            : _vm._e(),
          _vm.title === "编码设置"
            ? _c("codingSet", { attrs: { codingSetData: _vm.codingSetData } })
            : _vm._e(),
          _vm.title !== "编码设置"
            ? _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.dialogVisible = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.dialogVisible = false
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }